import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import { updateQuoteRequestTransport } from "#modules/quoteRequests/infra/updateQuoteRequestTransport.api";

export const useUpdateQuoteRequestTransport = (options: {
  onSuccess?: () => void;
  onError?: (err: Error) => void;
  onMutate?: () => void;
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateQuoteRequestTransport,
    onMutate: () => {
      options.onMutate?.();
    },
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries(quoteRequestQuery(variables.id));

      data.affectedQuoteRequestLineIds.forEach((qrlId) => {
        void queryClient.invalidateQueries(quoteRequestLineQuery({ id: qrlId }));
      });

      options.onSuccess?.();
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      options.onError?.(err);
    },
  });

  return { updateQuoteRequestTransport: mutate, ...rest };
};
